import React from 'react';
import { monthNames } from './constants';

const CalendarView = ({ leavesData, currentMonth, currentYear, setCurrentMonth, setCurrentYear, setSelectedDay }) => {
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const days = [];

  for (let i = 0; i < firstDay; i++) {
    days.push(<div key={`empty-${i}`} className="Leaves-calendar-empty"></div>);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const dateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const leavesOnDay = leavesData.filter(leave => 
      dateStr >= leave.startDate && dateStr <= leave.endDate
    );
    // const leavesOnDay = leavesData.filter(leave => 
    //   leave.status === "approved" &&
    //   dateStr >= leave.startDate && 
    //   dateStr <= leave.endDate
    // );
    days.push(
      <div 
        key={day}
        //className={`Leaves-calendar-day ${leavesOnDay.length > 0 ? 'Leaves-calendar-has-leaves' : ''}`}
        className={`Leaves-calendar-day ${leavesOnDay.some(l => l.status === 'approved') ? 'leave-approved' : ''} ${leavesOnDay.some(l => l.status === 'pending') ? 'leave-pending' : ''} ${leavesOnDay.some(l => l.status === 'rejected') ? 'leave-rejected' : ''} ${leavesOnDay.some(l => l.status === 'cancelled') ? 'leave-rejected' : ''}`}
        onClick={() => setSelectedDay(dateStr)}
      >
        <div className="Leaves-calendar-day-number">{day}</div>
        {leavesOnDay.length > 0 && (
          <div className="Leaves-calendar-leave-count">
            <span className="Leaves-leave-indicator">{leavesOnDay.length} leave{leavesOnDay.length > 1 ? 's' : ''}</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="Leaves-calendar-container">
      <div className="Leaves-calendar-header">
        <h3 className="Leaves-calendar-title">{monthNames[currentMonth]} {currentYear}</h3>
        <div className="Leaves-calendar-nav">
          <button 
            onClick={() => {
              if (currentMonth === 0) {
                setCurrentMonth(11);
                setCurrentYear(currentYear - 1);
              } else {
                setCurrentMonth(currentMonth - 1);
              }
            }}
            className="Leaves-nav-btn Leaves-nav-prev"
          >
            ←
          </button>
          <button 
            onClick={() => {
              if (currentMonth === 11) {
                setCurrentMonth(0);
                setCurrentYear(currentYear + 1);
              } else {
                setCurrentMonth(currentMonth + 1);
              }
            }}
            className="Leaves-nav-btn Leaves-nav-next"
          >
            →
          </button>
        </div>
      </div>
      <div className="Leaves-calendar-days-header">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
          <div key={day} className="Leaves-calendar-day-header">{day}</div>
        ))}
      </div>
      <div className="Leaves-calendar-grid">
        {days}
      </div>
    </div>
  );
};

export default CalendarView;